<div class="w-100-p" *ngIf="dataSource">
    <mat-table #table [dataSource]="dataSource" matSort matSortActive="{{ sortBy }}" matSortDirection="{{ sortOrder }}">
        <!-- Checkbox Column -->
        <ng-container matColumnDef="checkbox">
            <mat-header-cell *matHeaderCellDef>
                <mat-checkbox
                    (click)="$event.stopPropagation()"
                    (change)="$event ? toggle.emit(isAllSelected) : null"
                    [checked]="selectedRootUserIds.length && isAllSelected"
                    [indeterminate]="selectedRootUserIds.length && !isAllSelected"
                >
                </mat-checkbox>
            </mat-header-cell>
            <mat-cell *matCellDef="let user">
                <mat-checkbox [(ngModel)]="checkboxes[user.id]" (ngModelChange)="select.emit(user)" (click)="$event.stopPropagation()"> </mat-checkbox>
            </mat-cell>
        </ng-container>

        <!-- Avatar Column -->
        <ng-container matColumnDef="avatar">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
            <mat-cell *matCellDef="let user">
                <div class="relative" #avatarCell>
                    <img class="avatar pointer" *ngIf="user?.avatar.src; else initials" [alt]="user.fullName" [src]="user.avatar.src" />
                    <ng-template #initials>
                        <div fxLayoutAlign="center center" class="avatar-initials avatar">{{ user.fullName | initials }}</div>
                    </ng-template>
                    <ng-template [onlineStateIndicator]="user.isOnline"> </ng-template>
                </div>
            </mat-cell>
        </ng-container>

        <!-- First Name Column -->
        <ng-container matColumnDef="firstName">
            <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'GENERAL.PROPERTY.FIRST_NAME' | translate }} </mat-header-cell>
            <mat-cell *matCellDef="let user">
                <a *ngIf="user" class="text-truncate font-semibold" [routerLink]="['/users/' + user.id + '/edit']">{{ user.firstName }}</a>
            </mat-cell>
        </ng-container>

        <!-- Last Name Column -->
        <ng-container matColumnDef="lastName">
            <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'GENERAL.PROPERTY.LAST_NAME' | translate }} </mat-header-cell>
            <mat-cell *matCellDef="let user">
                <a *ngIf="user" class="text-truncate font-semibold" [routerLink]="['/users/' + user.id + '/edit']">{{ user.lastName }}</a>
            </mat-cell>
        </ng-container>

        <!-- Email Column -->
        <ng-container matColumnDef="email">
            <mat-header-cell *matHeaderCellDef mat-sort-header fxHide fxShow.gt-sm> {{ 'GENERAL.PROPERTY.EMAIL' | translate }}</mat-header-cell>
            <mat-cell *matCellDef="let user" fxHide fxShow.gt-sm>
                <a *ngIf="user" [href]="'mailto:' + user.email" target="_top">{{ user.email }}</a>
            </mat-cell>
        </ng-container>

        <!-- Buttons Column -->
        <ng-container matColumnDef="buttons">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
            <mat-cell *matCellDef="let user; let i = index">
                <div fxFlex="row" fxLayoutAlign="end center">
                    <button mat-icon-button [matMenuTriggerFor]="moreMenu" aria-label="More" (click)="$event.stopPropagation()">
                        <mat-icon class="mat-icon-more-vert">more_vert</mat-icon>
                    </button>
                    <mat-menu #moreMenu="matMenu" xPosition="before">
                        <button
                            mat-menu-item
                            (click)="openPasswordlessAccessDialog(user)"
                            [disabled]="user.status !== 'active'"
                            *ngIf="actionPermissions.canCreatePasswordless && actionPermissions.isPasswordlessLoginFeatureEnabled"
                        >
                            <mat-icon svgIcon="qr_code" class="mr-8"></mat-icon>
                            <span>{{ 'USER.BUTTON.CREATE_PASSWORDLESS_ACCESS' | translate }}</span>
                        </button>

                        <button mat-menu-item (click)="openAssignUserToTeamDialog(user)" *ngIf="actionPermissions.canAssignTeam">
                            <mat-icon svgIcon="team" class="mr-8"></mat-icon>
                            <span>{{ 'USER.BUTTON.ASSIGN_TO_TEAM' | translate }}</span>
                        </button>

                        <button mat-menu-item (click)="assignUserToExperience(user)" *ngIf="actionPermissions.canAssignExperience">
                            <mat-icon svgIcon="assign_user_to_experience" class="mr-8"></mat-icon>
                            <span>{{ 'GENERAL.BUTTON.ASSIGN_TO_EXPERIENCE' | translate }}</span>
                        </button>

                        <button mat-menu-item (click)="assignUserToAudience(user)" *ngIf="actionPermissions.canAssignAudience">
                            <mat-icon svgIcon="assign_user_to_audience" class="mr-8"></mat-icon>
                            <span>{{ 'GENERAL.BUTTON.ASSIGN_TO_AUDIENCE' | translate }}</span>
                        </button>

                        <button mat-menu-item (click)="assignUserToCourse(user)" *ngIf="actionPermissions.canAssignCourse">
                            <mat-icon class="mr-8">school</mat-icon>
                            <span>{{ 'GENERAL.BUTTON.TAKE_OVER' | translate }}</span>
                        </button>

                        <button
                            mat-menu-item
                            (click)="resetPassword(user)"
                            *ngIf="actionPermissions.canResetPassword && !actionPermissions.isSSOFeatureEnabled"
                        >
                            <mat-icon svgIcon="lock_reset" class="mr-8"></mat-icon>
                            <span>{{ 'USER.BUTTON.RESET_PASSWORDS' | translate: { total: 1 } }}</span>
                        </button>

                        <app-menu-item-button
                            aria-label="move"
                            [icon]="'drive_file_move'"
                            [label]="'GENERAL.BUTTON.MOVE_TO'"
                            (onClick)="moveMember(user.id)"
                            [showThreeDots]="true"
                        ></app-menu-item-button>

                        <button mat-menu-item (click)="removeUser(user)" *ngIf="actionPermissions.canRemove">
                            <mat-icon class="mr-8">delete</mat-icon>
                            <span>{{ 'GENERAL.BUTTON.REMOVE' | translate }}</span>
                        </button>
                    </mat-menu>
                </div>
            </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let user; columns: displayedColumns" class="user" [ngClass]="{ 'accent-50': checkboxes[user.id] }" matRipple> </mat-row>
    </mat-table>

    <mat-paginator persistPageSize="grow.root-audience-users-list" [length]="totalCount$ | async" [pageSize]="10" [pageSizeOptions]="[10, 25, 50]"></mat-paginator>
</div>
